import { axiosInstance } from './axiosInstance';

export const apiRequests = {
  currencies: {
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminGeneral/GetCurrencies', { params: { count, offset } });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetCurrency', { params: { id } });
    },
    getFiltered: async (query) => {
      return axiosInstance.get('/AdminGeneral/GetCurrenciesFiltered', { params: { query } });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteCurrency', { params: { id } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminGeneral/CreateCurrency', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateCurrencyMain', body);
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminGeneral/CreateCurrencyLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateCurrencyLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteCurrencyLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetCurrencyLocalizations', { params: { id } });
    },
  },
  countriesGroups: {
    get: async (count = 50, offset = 0) => {
      return axiosInstance.get('/AdminGeneral/GetCountriesGroups', { params: { count, offset } });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetCountriesGroup', { params: { id } });
    },
    getFiltered: async (query) => {
      return axiosInstance.get('/AdminGeneral/GetCountriesGroupsFiltered', { params: { query } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminGeneral/CreateCountriesGroup', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateCountriesGroup', body);
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteCountriesGroup', { params: { id } });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminGeneral/CreateCountriesGroupLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateCountriesGroupLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteCountriesGroupLocalization', {
        params: { id },
      });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetCountriesGroupLocalizations', { params: { id } });
    },
  },
  countries: {
    get: async (count = 150, offset = 0) => {
      return axiosInstance.get('/AdminGeneral/GetCountries', { params: { count, offset } });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetCountry', { params: { id } });
    },
    getFiltered: async (query) => {
      return axiosInstance.get('/AdminGeneral/GetCountriesFiltered', { params: { query } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminGeneral/CreateCountry', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateCountryMain', body);
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminGeneral/CreateCountryLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateCountryLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteCountryLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetCountryLocalizations', { params: { id } });
    },
  },
  languages: {
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminGeneral/GetLanguages', { params: { count, offset } });
    },
    getFiltered: async (query) => {
      return axiosInstance.get('/AdminGeneral/GetLanguagesFiltered', { params: { query } });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteLanguage', { params: { id } });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetLanguage', { params: { id } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminGeneral/CreateLanguage', body);
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminGeneral/CreateLanguageLocalization', body, {
        params: { itemId },
      });
    },
    update: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateLanguageMain', body);
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateLanguageLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteLanguageLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetLanguageLocalizations', { params: { id } });
    },
    getLocalizations: async (languageId) => {
      return axiosInstance.get('/AdminInterfaceTextsStructure/GetInterfaceTextsStructure', {
        params: { languageId },
      });
    },
  },
  reviews: {
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminReviews/GetReviews', { params: { count, offset } });
    },
    count: async () => {
      return axiosInstance.get('/AdminReviews/GetReviewsCount');
    },
    getWithFilters: async (
      query = undefined,
      showOnlyHidden = undefined,
      count = 20,
      offset = 0,
    ) => {
      return axiosInstance.get('/AdminReviews/GetReviewsFiltered', {
        params: { count, offset, showOnlyHidden, query },
      });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminReviews/DeleteReview', { params: { id } });
    },
    hide: async (id, value) => {
      return axiosInstance.put('/AdminReviews/SetReviewHidden', null, {
        params: { id, val: value },
      });
    },
  },
  complianceDocuments: {
    get: async (count = 10, offset = 0) => {
      return axiosInstance.get(`/AdminCompliance/GetComplianceDocuments`, {
        params: { count, offset },
      });
    },
    getFiltered: async (query, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      return axiosInstance.get('/AdminCompliance/GetComplianceDocuments', { params });
    },
    create: async (body) => {
      return axiosInstance.postForm('/AdminCompliance/CreateComplianceDocument', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminCompliance/UpdateComplianceDocumentMain', body);
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminCompliance/UpdateAvailability', body);
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminCompliance/GetComplianceDocument', { params: { id } });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminCompliance/DeleteComplianceDocument', { params: { id } });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminCompliance/CreateComplianceDocumentLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminCompliance/UpdateComplianceDocumentLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminCompliance/DeleteComplianceDocumentLocalization', {
        params: { id },
      });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminCompliance/GetComplianceDocumentLocalizations', {
        params: { id },
      });
    },
  },
  partners: {
    get: async (count = 10, offset = 0) => {
      return axiosInstance.get(`/AdminPartners/GetPartners`, { params: { count, offset } });
    },
    getFiltered: async (query, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      return axiosInstance.get('/AdminPartners/GetPartners', { params });
    },
    create: async (body) => {
      return axiosInstance.postForm('/AdminPartners/CreatePartner', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminPartners/UpdatePartnerMain', body);
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminPartners/DeletePartnerLocalization', body);
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminPartners/GetPartner', { params: { id } });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminPartners/DeletePartner', { params: { id } });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminPartners/CreatePartnerLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminPartners/UpdatePartnerLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminPartners/DeletePartnerLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminPartners/GetPartnerLocalizations', { params: { id } });
    },
  },
  visits: {
    get: async (params) => {
      return axiosInstance.get('/AdminStats/GetVisits', { params });
    },
    getByDays: async (params) => {
      return axiosInstance.get('/AdminStats/GetVisitsByDay', { params });
    },
    getByDayCount: async (from, to) => {
      return axiosInstance.get('/AdminStats/GetVisitsByDayCount', { params: { from, to } });
    },
  },
  services: {
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminServicePages/GetServicePages', { params: { count, offset } });
    },
    getFiltered: async (query, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      return axiosInstance.get('/AdminServicePages/GetServicePages', { params });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminServicePages/CreateServicePageLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminServicePages/UpdateServicePageLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminServicePages/DeleteServicePageLocalization', {
        params: { id },
      });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminServicePages/GetServicePageLocalizations', {
        params: { id },
      });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminServicePages/GetServicePage', { params: { id } });
    },
    createService: async (body) => {
      return axiosInstance.postForm('/AdminServicePages/CreateServicePage', body);
    },
    updateService: async (body) => {
      return axiosInstance.put('/AdminServicePages/UpdateServicePageMain', body);
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminServicePages/UpdateAvailability', body);
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminServicePages/DeleteServicePage', { params: { id } });
    },
    deleteRibbon: async (id, mainEntityId, mainEntityIdFor = 1) => {
      return axiosInstance.delete('/AdminServicePages/DeleteServiceRibbonItem', {
        params: { id, mainEntityId, mainEntityIdFor },
      });
    },
    deleteReview: async (id, mainEntityId, mainEntityIdFor = 1) => {
      return axiosInstance.delete('/AdminServicePages/DeleteReview', {
        params: { id, mainEntityId, mainEntityIdFor },
      });
    },
    deleteIcon: async (iconId, servicePageId) => {
      return axiosInstance.delete('/AdminServicePages/DeleteStackIcon', {
        params: { iconId, servicePageId },
      });
    },
    addIconService: async (body, servicePageId) => {
      return axiosInstance.postForm('/AdminServicePages/AddStackIcon', body, {
        params: { servicePageId },
      });
    },
    addReviewService: async (body, mainEntityIdFor, mainEntityId) => {
      return axiosInstance.postForm('/AdminServicePages/CreateReview', body, {
        params: { mainEntityIdFor, mainEntityId },
      });
    },
    addRibbenService: async (body, mainEntityIdFor, mainEntityId) => {
      return axiosInstance.post('/AdminServicePages/CreateServiceRibbonItem', body, {
        params: { mainEntityIdFor, mainEntityId },
      });
    },
  },
  news: {
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminMassMediaPosts/GetPosts', { params: { count, offset } });
    },
    getFiltered: async (query, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      return axiosInstance.get('/AdminMassMediaPosts/GetPosts', { params });
    },
    create: async (body) => {
      return axiosInstance.postForm('/AdminMassMediaPosts/CreatePost', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminMassMediaPosts/UpdatePostMain', body);
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminMassMediaPosts/UpdateAvailability', body);
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminMassMediaPosts/GetPost', { params: { id } });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminMassMediaPosts/DeletePost', { params: { id } });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminMassMediaPosts/CreatePostLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminMassMediaPosts/UpdatePostLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminMassMediaPosts/DeletePostLocalization', {
        params: { id },
      });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminMassMediaPosts/GetPostLocalizations', { params: { id } });
    },
  },
  posts: {
    get: async (count = 20, offset = 0, query = '', categoryId = null, industryId = null) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (categoryId) params.categoryId = categoryId;
      if (industryId) params.industryId = industryId;
      return axiosInstance.get('/AdminPosts/GetPosts', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminPosts/GetPost', { params: { id } });
    },
    getFiltered: async (query = '', categoryId = null, industryId = null, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (categoryId) params.categoryId = categoryId;
      if (industryId) params.industryId = industryId;
      return axiosInstance.get('/AdminPosts/GetPosts', { params });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminPosts/CreatePostLocalization', body, { params: { itemId } });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminPosts/UpdatePostLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminPosts/DeletePostLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminPosts/GetPostLocalizations', { params: { id } });
    },
    createLocaleEntityCategory: async (body, itemId) => {
      return axiosInstance.post('/AdminPosts/CreatePostLocalization', body, { params: { itemId } });
    },
    updateLocaleEntityCategory: async (body) => {
      return axiosInstance.put('/AdminPosts/UpdatePostCategoryLocalization', body);
    },
    deleteLocaleEntityCategory: async (id) => {
      return axiosInstance.delete('/AdminPosts/DeletePostCategoryLocalization', { params: { id } });
    },
    getEntityLocaleCategory: async (id) => {
      return axiosInstance.get('/AdminPosts/GetPostCategoryLocalizations', { params: { id } });
    },
    getCategories: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminPosts/GetPostCategories', { params: { count, offset } });
    },
    getCategoriesFiltered: async (query) => {
      return axiosInstance.get('/AdminPosts/GetPostCategoriesFiltered', { params: { query } });
    },
    getCategory: async (id) => {
      return axiosInstance.get('/AdminPosts/GetPostCategory', { params: { id } });
    },
    getIndustry: async (id) => {
      return axiosInstance.get('/AdminPosts/GetPostIndustry', { params: { id } });
    },
    getIndustries: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminPosts/GetPostIndustries', { params: { count, offset } });
    },
    getIndustriesFiltered: async (query) => {
      return axiosInstance.get('/AdminPosts/GetPostIndustriesFiltered', { params: { query } });
    },
    createCategory: async (body) => {
      return axiosInstance.post('/AdminPosts/CreatePostCategory', body);
    },
    createIndustry: async (body) => {
      return axiosInstance.post('/AdminPosts/CreatePostIndustry', body);
    },
    create: async (body) => {
      return axiosInstance.post('/AdminPosts/CreatePost', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    updateCategory: async (body) => {
      return axiosInstance.put('/AdminPosts/UpdatePostCategoryMain', body);
    },
    updateIndustry: async (body) => {
      return axiosInstance.put('/AdminPosts/UpdatePostIndustryMain', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminPosts/UpdatePostMain', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminPosts/UpdateAvailability', body);
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminPosts/DeletePost', { params: { id } });
    },
    deleteCategory: async (id) => {
      return axiosInstance.delete('/AdminPosts/DeletePostCategory', { params: { id } });
    },
    deleteIndustry: async (id) => {
      return axiosInstance.delete('/AdminPosts/DeletePostIndustry', { params: { id } });
    },
  },
  portfolio: {
    get: async (count = 20, offset = 0, query = '', categoryId = null, industryId = null) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (categoryId) params.categoryId = categoryId;
      if (industryId) params.industryId = industryId;
      return axiosInstance.get('/AdminPortfolio/GetPortfolios', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolio', { params: { id } });
    },
    getFiltered: async (query = '', categoryId = null, industryId = null, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (categoryId) params.categoryId = categoryId;
      if (industryId) params.industryId = industryId;
      return axiosInstance.get('/AdminPortfolio/GetPortfolios', { params });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminPortfolio/CreatePortfolioLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminPortfolio/UpdatePortfolioLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminPortfolio/DeletePortfolioLocalization', {
        params: { id },
      });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioLocalizations', { params: { id } });
    },
    createLocaleEntityCategory: async (body, itemId) => {
      return axiosInstance.post('/AdminPortfolio/CreatePortfolioLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntityCategory: async (body) => {
      return axiosInstance.put('/AdminPortfolio/UpdatePortfolioCategoryLocalization', body);
    },
    deleteLocaleEntityCategory: async (id) => {
      return axiosInstance.delete('/AdminPortfolio/DeletePortfolioCategoryLocalization', {
        params: { id },
      });
    },
    getEntityLocaleCategory: async (id) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioCategoryLocalizations', {
        params: { id },
      });
    },
    getCategories: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioCategories', {
        params: { count, offset },
      });
    },
    getCategoriesFiltered: async (query) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioCategoriesFiltered', {
        params: { query },
      });
    },
    getCategory: async (id) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioCategory', { params: { id } });
    },
    getIndustry: async (id) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioIndustry', { params: { id } });
    },
    getIndustries: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioIndustries', {
        params: { count, offset },
      });
    },
    getIndustriesFiltered: async (query) => {
      return axiosInstance.get('/AdminPortfolio/GetPortfolioIndustriesFiltered', {
        params: { query },
      });
    },
    createCategory: async (body) => {
      return axiosInstance.post('/AdminPortfolio/CreatePortfolioCategory', body);
    },
    createIndustry: async (body) => {
      return axiosInstance.post('/AdminPortfolio/CreatePortfolioIndustry', body);
    },
    create: async (body) => {
      return axiosInstance.postForm('/AdminPortfolio/CreatePortfolio', body);
    },
    updateCategory: async (body) => {
      return axiosInstance.put('/AdminPortfolio/UpdatePortfolioCategoryMain', body);
    },
    updateIndustry: async (body) => {
      return axiosInstance.put('/AdminPortfolio/UpdatePortfolioIndustryMain', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminPortfolio/UpdatePortfolioMain', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminPortfolio/UpdateAvailability', body);
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminPortfolio/DeletePortfolio', { params: { id } });
    },
    deleteCategory: async (id) => {
      return axiosInstance.delete('/AdminPortfolio/DeletePortfolioCategory', { params: { id } });
    },
    deleteIndustry: async (id) => {
      return axiosInstance.delete('/AdminPortfolio/DeletePortfolioIndustry', { params: { id } });
    },
  },
  users: {
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminUsers/GetUsers', { params: { count, offset } });
    },
    count: async () => {
      return axiosInstance.get('/AdminUsers/GetUsersCount');
    },
    getFiltered: async (query, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      return axiosInstance.get('/AdminUsers/GetUsers', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminUsers/GetUserMainInfo', { params: { id } });
    },
    getAccessList: async (id) => {
      return axiosInstance.get('/AdminUsers/GetUserRoleModel', { params: { id } });
    },
    update: async (body) => {
      return axiosInstance.put('/AdminUsers/UpdateUser', body);
    },
    updateAccess: async (body, userId) => {
      return axiosInstance.put('/AdminUsers/UpdateUserRoles', body, { params: { userId } });
    },
    updateAvatar: async (body) => {
      return axiosInstance.put('/Users/UploadAvatar', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    getUser: async () => {
      return axiosInstance.get('/Users/GetUserBySessionToken');
    },
    refreshToken: async (refreshToken) => {
      return axiosInstance.put('/Users/Refresh', undefined, {
        params: { refreshToken },
      });
    },
    auth: async (body) => {
      return axiosInstance.post('/Users/Login', body);
    },
    ban: async (body) => {
      const { Id, ...rest } = body;
      return axiosInstance.put(`/AdminUsers/BanUser?id=${Id}`, rest);
    },
    unban: async (id) => {
      return axiosInstance.put('/AdminUsers/UnbanUser', null, { params: { id } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminUsers/CreateUser', body);
    },
    createRole: async (body) => {
      return axiosInstance.post('/AdminUsers/CreateUser', body);
    },
  },
  promocodes: {
    get: async (count = 20, offset = 0, query = '') => {
      return axiosInstance.get('/AdminShop/GetPromocodes', { params: { count, offset, query } });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminShop/GetPromocode', { params: { id } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminShop/CreatePromocode', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminShop/UpdatePromocode', body);
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminShop/DeletePromocode', { params: { id } });
    },
  },
  applicationForms: {
    get: async (count = 20, offset = 0, status, from, to, sentFormType) => {
      return axiosInstance.get('/AdminForms/GetForms', { 
        params: { 
          count, 
          offset, 
          status, 
          from, 
          to, 
          sentFormType 
        } 
      });
    },
  },
  products: {
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminShop/GetProducts', { params: { count, offset } });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminShop/GetProduct', { params: { id } });
    },
    count: () => {
      return axiosInstance.get('/AdminShop/GetProductsCount');
    },
    addPhoto: async (body, productId) => {
      return axiosInstance.postForm(
        '/AdminShop/AddProductPhoto',
        { mainImg: body },
        { params: { productId } },
      );
    },
    deletePhoto: async (productId, photoId) => {
      return axiosInstance.delete('/AdminShop/DeleteProductPhoto', {
        params: { productId, photoId },
      });
    },
    addPhotoLocalization: async (body, localizationId) => {
      return axiosInstance.postForm(
        '/AdminShop/AddProductLocalizationPhoto',
        { mainImg: body },
        { params: { localizationId } },
      );
    },
    deletePhotoLocalization: async (localizationId, photoId) => {
      return axiosInstance.delete('/AdminShop/DeleteProductLocalizationPhoto', {
        params: { localizationId, photoId },
      });
    },
    create: async (body) => {
      return axiosInstance.postForm('/AdminShop/CreateProduct', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminShop/UpdateProductMain', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    getOrders: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminShop/GetOrders', { params: { count, offset } });
    },
    getOrdersFiltered: async (status, query, page, count = 20, offset = 0) => {
      return axiosInstance.get('/AdminShop/GetOrdersFiltered', {
        params: { count, query, offset, status, page },
      });
    },
    getModificators: async (productId) => {
      return axiosInstance.get('/AdminShop/GetProductModifiers', { params: { productId } });
    },
    getModificatorById: async (id) => {
      return axiosInstance.get('/AdminShop/GetProductModifier', { params: { id } });
    },
    getCategories: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminShop/GetProductCategories', { params: { count, offset } });
    },
    getCategory: async (id) => {
      return axiosInstance.get('/AdminShop/GetProductCategory', { params: { id } });
    },
    filter: async (count = 20, offset = 0, query = '', categoryId = null) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (categoryId) params.categoryId = categoryId;
      return axiosInstance.get('/AdminShop/GetProducts', { params });
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminShop/UpdateAvailability', body);
    },
    createCategory: async (body) => {
      return axiosInstance.post('/AdminShop/CreateProductCategory', body);
    },
    createModifier: async (body) => {
      return axiosInstance.post('/AdminShop/CreateProductModifier', body);
    },
    updateModifier: async (body) => {
      return axiosInstance.put('/AdminShop/UpdateProductModifierMain', body);
    },
    deleteModifier: async (id) => {
      return axiosInstance.delete('/AdminShop/DeleteProductModifier', { params: { id } });
    },
    createModifierOption: async (body) => {
      return axiosInstance.post('/AdminShop/CreateProductModifierOption', body);
    },
    updateModifierOption: async (body) => {
      return axiosInstance.put('/AdminShop/UpdateProductModifierOptionMain', body);
    },
    deleteModifierOption: async (id) => {
      return axiosInstance.delete('/AdminShop/DeleteProductModifierOption', { params: { id } });
    },
    updateCategory: async (body) => {
      return axiosInstance.put('/AdminShop/UpdateProductCategoryMain', body);
    },
    deleteCategory: async (id) => {
      return axiosInstance.delete('/AdminShop/DeleteProductCategory', { params: { id } });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminShop/DeleteProduct', { params: { id } });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminShop/CreateProductLocalization', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminShop/UpdateProductLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminShop/DeleteProductLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminShop/GetProductLocalizations', { params: { id } });
    },
    createLocaleEntityCategory: async (body, itemId) => {
      return axiosInstance.post('/AdminShop/CreateProductCategoryLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntityCategory: async (body) => {
      return axiosInstance.put('/AdminShop/UpdateProductCategoryLocalization', body);
    },
    deleteLocaleEntityCategory: async (id) => {
      return axiosInstance.delete('/AdminShop/DeleteProductCategoryLocalization', {
        params: { id },
      });
    },
    getEntityLocaleCategory: async (id) => {
      return axiosInstance.get('/AdminShop/GetProductCategoryLocalizations', { params: { id } });
    },
  },
  team: {
    getMembers: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminTeam/GetTeamMembers', { params: { count, offset } });
    },
    getStructures: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminTeam/GetTeamStructures', { params: { count, offset } });
    },
    deleteStructure: async (id) => {
      return axiosInstance.delete('/AdminTeam/DeleteTeamStructure', { params: { id } });
    },
    deleteGroup: async (id) => {
      return axiosInstance.delete('/AdminTeam/DeleteTeamGroup', { params: { id } });
    },
    deleteMember: async (id) => {
      return axiosInstance.delete('/AdminTeam/DeleteTeamMember', { params: { id } });
    },
    getStructure: async (id) => {
      return axiosInstance.get('/AdminTeam/GetTeamStructure', { params: { id } });
    },
    getGroups: async (count = 100, offset = 0, structureId) => {
      return axiosInstance.get('/AdminTeam/GetTeamGroups', {
        params: { count, offset, structureId },
      });
    },
    getGroup: async (structureId, id) => {
      return axiosInstance.get('/AdminTeam/GetTeamGroup', { params: { structureId, groupId: id } });
    },
    createGroup: async (body) => {
      return axiosInstance.post('/AdminTeam/AddTeamGroup', body);
    },
    createTeamStructure: async (body) => {
      return axiosInstance.post('/AdminTeam/CreateTeamStructure', body);
    },
    updateTeamStructure: async (body) => {
      return axiosInstance.post('/AdminTeam/UpdateTeamStructure', body);
    },
    createMember: async (body) => {
      return axiosInstance.postForm('/AdminTeam/AddTeamMember', body);
    },
    updateGroup: async (body) => {
      return axiosInstance.put('/AdminTeam/UpdateTeamGroupMain', body);
    },
    updateMember: async (body) => {
      return axiosInstance.putForm('/AdminTeam/UpdateTeamMemberMain', body);
    },
    getMember: async (groupId, memberId) => {
      return axiosInstance.get('/AdminTeam/GetTeamMember', { params: { groupId, memberId } });
    },
  },
  outstuff: {
    // Матрица
    get: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminOutstaff/GetOutstaffMatrix', { params: { count, offset } });
    },
    // Услуги (Items)
    createItem: async (body) => {
      return axiosInstance.post('/AdminOutstaff/CreateOutstaffItem', body);
    },
    updateItem: async (body) => {
      return axiosInstance.put('/AdminOutstaff/UpdateOutstaffItemMain', body);
    },
    deleteItem: async (id) => {
      return axiosInstance.delete('/AdminOutstaff/DeleteOutstaffItem', { params: { id } });
    },
    // Грейды (ItemGrades)
    createItemGrade: async (body) => {
      return axiosInstance.post('/AdminOutstaff/CreateOutstaffItemGrade', body);
    },
    updateGrade: async (body) => {
      return axiosInstance.put('/AdminOutstaff/UpdateOutstaffItemGradeMain', body);
    },
    deleteGrade: async (id) => {
      return axiosInstance.delete('/AdminOutstaff/DeleteOutstaffItemGrade', { params: { id } });
    },
    // Колонки (периоды)
    createColumn: async (body) => {
      return axiosInstance.post('/AdminOutstaff/CreateOutstaffColumn', body);
    },
    updateColumn: async (body) => {
      return axiosInstance.put('/AdminOutstaff/UpdateOutstaffColumnMain', body);
    },
    deleteColumn: async (id) => {
      return axiosInstance.delete('/AdminOutstaff/DeleteOutstaffColumn', { params: { id } });
    },
    // Цены (ColumnGrades)
    createColumnGrade: async (body) => {
      return axiosInstance.post('/AdminOutstaff/CreateOutstaffItemGradeColumn', body);
    },
    updateColumnGrade: async (body) => {
      return axiosInstance.put('/AdminOutstaff/UpdateOutstaffItemGradeColumn', body);
    },
    deleteColumnGrade: async (id) => {
      return axiosInstance.delete('/AdminOutstaff/DeleteOutstaffItemGradeColumn', { params: { id } });
    },
    // Матрица цен
    updatePricingMatrix: async (body) => {
      return axiosInstance.put('/AdminOutstaff/UpdatePricingMatrix', body);
    },
    setDefaultPricingMatrix: async (cellId) => {
      return axiosInstance.put('/AdminOutstaff/SetDefaultCellPricingMatrix', null, { params: { cellId } });
    },
  },
  events: {
    get: async (count = 20, offset = 0, query = '', categoryId = null, formatId = null) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (categoryId) params.categoryId = categoryId;
      if (formatId) params.formatId = formatId;
      return axiosInstance.get('/AdminEvents/GetEvents', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminEvents/GetEvent', { params: { id } });
    },
    getFiltered: async (query = '', categoryId = null, formatId = null, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (categoryId) params.categoryId = categoryId;
      if (formatId) params.formatId = formatId;
      return axiosInstance.get('/AdminEvents/GetEvents', { params });
    },
    getCategory: async (id) => {
      return axiosInstance.get('/AdminEvents/GetEventCategory', { params: { id } });
    },
    getCategories: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminEvents/GetEventCategories', { params: { count, offset } });
    },
    getCategoriesFiltered: async (query) => {
      return axiosInstance.get('/AdminEvents/GetEventCategoriesFiltered', { params: { query } });
    },
    getFormat: async (id) => {
      return axiosInstance.get('/AdminEvents/GetEventFormat', { params: { id } });
    },
    getFormats: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminEvents/GetEventFormats', { params: { count, offset } });
    },
    getFormatsFiltered: async (query) => {
      return axiosInstance.get('/AdminEvents/GetEventFormatsFiltered', { params: { query } });
    },
    getTimezones: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminGeneral/GetTimezones', { params: { count, offset } });
    },
    getTimezone: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetTimezone', { params: { id } });
    },
    getTimezonesFiltered: async (query) => {
      return axiosInstance.get('/AdminGeneral/GetTimezonesFiltered', { params: { query } });
    },
    update: async (body) => {
      return axiosInstance.put('/AdminEvents/UpdateEventMain', body);
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminEvents/UpdateAvailability', body);
    },
    updateFormat: async (body) => {
      return axiosInstance.put('/AdminEvents/UpdateEventFormatMain', body);
    },
    updateCategory: async (body) => {
      return axiosInstance.put('/AdminEvents/UpdateEventCategoryMain', body);
    },
    create: async (body) => {
      return axiosInstance.postForm('/AdminEvents/CreateEvent', body);
    },
    createCategory: async (body) => {
      return axiosInstance.post('/AdminEvents/CreateEventCategory', body);
    },
    createFormat: async (body) => {
      return axiosInstance.post('/AdminEvents/CreateEventFormat', body);
    },
    createTimezone: async (body) => {
      return axiosInstance.post('/AdminGeneral/CreateTimezone', body);
    },
    updateTimezone: async (body, id) => {
      return axiosInstance.put('/AdminGeneral/UpdateTimezone', body, { params: { id } });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminEvents/DeleteEvent', { params: { id } });
    },
    deleteCategory: async (id) => {
      return axiosInstance.delete('/AdminEvents/DeleteEventCategory', { params: { id } });
    },
    deleteTimezone: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteTimezone', { params: { id } });
    },
    deleteFormat: async (id) => {
      return axiosInstance.delete('/AdminEvents/DeleteEventFormat', { params: { id } });
    },
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminEvents/CreateEventLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.post('/AdminEvents/UpdateEventLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminEvents/DeleteEventLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminEvents/GetEventLocalizations', { params: { id } });
    },
    createLocaleEntityCategory: async (body, itemId) => {
      return axiosInstance.post('/AdminEvents/CreateEventCategoryLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntityCategory: async (body) => {
      return axiosInstance.put('/AdminEvents/UpdateEventCategoryLocalization', body);
    },
    deleteLocaleEntityCategory: async (id) => {
      return axiosInstance.delete('/AdminEvents/DeleteEventCategoryLocalization', {
        params: { id },
      });
    },
    getEntityLocaleCategory: async (id) => {
      return axiosInstance.get('/AdminEvents/GetEventCategoryLocalizations', { params: { id } });
    },
    createLocaleEntityFormat: async (body, itemId) => {
      return axiosInstance.post('/AdminEvents/CreateEventFormatLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntityFormat: async (body) => {
      return axiosInstance.put('/AdminEvents/UpdateEventFormatLocalization', body);
    },
    deleteLocaleEntityFormat: async (id) => {
      return axiosInstance.delete('/AdminEvents/DeleteEventFormatLocalization', { params: { id } });
    },
    getEntityLocaleFormat: async (id) => {
      return axiosInstance.get('/AdminEvents/GetEventFormatLocalizations', { params: { id } });
    },
  },
  timezones: {
    createLocaleEntity: async (body, itemId) => {
      return axiosInstance.post('/AdminGeneral/CreateTimezoneLocalization', body, {
        params: { itemId },
      });
    },
    updateLocaleEntity: async (body) => {
      return axiosInstance.put('/AdminGeneral/UpdateTimezoneLocalization', body);
    },
    deleteLocaleEntity: async (id) => {
      return axiosInstance.delete('/AdminGeneral/DeleteTimezoneLocalization', { params: { id } });
    },
    getEntityLocale: async (id) => {
      return axiosInstance.get('/AdminGeneral/GetTimezoneLocalizations', { params: { id } });
    },
  },
  hr: {
    get: async (count = 20, offset = 0, categoryId = null, query = null) => {
      // Создаем объект параметров с основными значениями
      const params = { count, offset };
      
      // Добавляем опциональные параметры, если они предоставлены
      if (categoryId) params.categoryId = categoryId;
      if (query) params.query = query;
      
      console.log('Параметры запроса вакансий:', params);
      
      return axiosInstance.get('/AdminHR/GetJobVacancies', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminHR/GetJobVacancy', { params: { id } });
    },
    getCategories: async (count = 20, offset = 0) => {
      return axiosInstance.get('/AdminHR/GetJobVacancyCategories', { params: { count, offset } });
    },
    getCategoriesFiltered: async (query) => {
      return axiosInstance.get('/AdminHR/GetJobVacancyCategoriesFiltered', { params: { query } });
    },
    getVacanciesFiltered: async (params) => {
      return axiosInstance.get('/AdminHR/GetJobVacanciesFiltered', { params });
    },
    getCategory: async (id) => {
      return axiosInstance.get('/AdminHR/GetJobVacancyCategory', { params: { id } });
    },
    deleteCategory: async (id) => {
      return axiosInstance.delete('/AdminHR/DeleteJobVacancyCategory', { params: { id } });
    },
    createCategory: async (body) => {
      return axiosInstance.post('/AdminHR/CreateJobVacancyCategory', body);
    },
    updateCategory: async (body) => {
      return axiosInstance.put('/AdminHR/UpdateJobVacancyCategory', body);
    },
    getSummaries: async (vacancyId, status = null, query = null, count = 20, offset = 0) => {
      // Создаем объект параметров с обязательными полями
      const params = { vacancyId, count, offset };
      
      // Добавляем опциональные параметры
      if (status) params.status = status;
      if (query) params.query = query;
      
      return axiosInstance.get('/AdminHR/GetJobSummaries', { params });
    },
    getSummary: async (id) => {
      return axiosInstance.get('/AdminHR/GetJobSummary', { params: { id } });
    },
    updateSummary: async (body) => {
      return axiosInstance.put('/AdminHR/UpdateJobSummary', body);
    },
    createVacancy: async (body) => {
      return axiosInstance.post('/AdminHR/CreateJobVacancy', body);
    },
    updateVacancy: async (body) => {
      return axiosInstance.put('/AdminHR/UpdateJobVacancyMain', body);
    },
    updateAvailability: async (body) => {
      return axiosInstance.put('/AdminHR/UpdateAvailability', body);
    },
    deleteVacancy: async (id) => {
      return axiosInstance.delete('/AdminHR/DeleteJobVacancy', { params: { id } });
    },
  },
  referralProgram: {
    // Получение участников
    getMembers: async (query = '', isAgreementSigned = null, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (isAgreementSigned !== null) params.isAgreementSigned = isAgreementSigned;
      return axiosInstance.get('/AdminRefProgram/GetReferralMembers', { params });
    },
    getMember: async (refUserId) => {
      return axiosInstance.get('/AdminRefProgram/GetReferralMember', { params: { refUserId } });
    },
    getMemberReferrals: async (refUserId, count = 20, offset = 0) => {
      return axiosInstance.get('/AdminRefProgram/GetReferralMemberReferrals', {
        params: { refUserId, count, offset },
      });
    },

    // Блокировка и разблокировка
    banUser: async (refUserId, body) => {
      return axiosInstance.post('/AdminRefProgram/BanRefUser', body, { params: { refUserId } });
    },
    unbanUser: async (refUserId) => {
      return axiosInstance.post('/AdminRefProgram/UnbanRefUser', null, { params: { refUserId } });
    },

    // Счета и транзакции
    getAccounts: async (refUserId) => {
      return axiosInstance.get('/AdminRefProgram/GetAccounts', { params: { refUserId } });
    },
    getAccount: async (accountId) => {
      return axiosInstance.get('/AdminRefProgram/GetAccount', { params: { accountId } });
    },
    getTransactions: async (accountId, count = 20, offset = 0) => {
      return axiosInstance.get('/AdminRefProgram/GetTransactions', {
        params: { accountId, count, offset },
      });
    },

    // Заявки на выплату
    getWithdrawalRequests: async (status = null, referralUserId = null, query = '', count = 20, offset = 0) => {
      const params = { count, offset };
      if (status !== null) params.status = status;
      if (referralUserId !== null) params.referralUserId = referralUserId;
      if (query) params.query = query;
      return axiosInstance.get('/AdminRefProgram/GetWithdrawalRequests', { params });
    },
    getWithdrawalRequest: async (requestId) => {
      return axiosInstance.get('/AdminRefProgram/GetWithdrawalRequest', { params: { requestId } });
    },
    updateWithdrawalRequest: async (body) => {
      return axiosInstance.put('/AdminRefProgram/UpdateWithdrawalRequest', body);
    },
  },
  investProjects: {
    // Получение проектов
    get: async (query = '', count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      return axiosInstance.get('/AdminInvestProjects/GetProjects', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminInvestProjects/GetProject', { params: { id } });
    },
    create: async (formData) => {
      return axiosInstance.post('/AdminInvestProjects/CreateProject', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    update: async (formData) => {
      return axiosInstance.put('/AdminInvestProjects/UpdateProject', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminInvestProjects/DeleteProject', { params: { id } });
    },

    // Локализация
    getLocalizations: async (id) => {
      return axiosInstance.get('/AdminInvestProjects/GetProjectLocalizations', { params: { id } });
    },
    getLocalization: async (id) => {
      return axiosInstance.get('/AdminInvestProjects/GetProjectLocalization', { params: { id } });
    },
    createLocalization: async (itemId, formData) => {
      return axiosInstance.post('/AdminInvestProjects/CreateProjectLocalization', formData, {
        params: { itemId },
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    updateLocalization: async (body) => {
      return axiosInstance.put('/AdminInvestProjects/UpdateProjectLocalization', body);
    },
    deleteLocalization: async (id) => {
      return axiosInstance.delete('/AdminInvestProjects/DeleteProjectLocalization', {
        params: { id },
      });
    },
  },
  orders: {
    // Получение заказов
    get: async (query = '', status = null, count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      if (status !== null) params.status = status;
      return axiosInstance.get('/AdminOrders/GetOrders', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminOrders/GetOrder', { params: { id } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminOrders/CreateOrder', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminOrders/UpdateOrder', body);
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminOrders/DeleteOrder', { params: { id } });
    },
    setStatus: async (orderId, status) => {
      return axiosInstance.put('/AdminOrders/SetOrderStatus', null, {
        params: { orderId, status },
      });
    },

    // Платежи
    createPayment: async (body) => {
      return axiosInstance.post('/AdminOrders/CreateOrderPayment', body);
    },
  },
  documents: {
    // Получение документов
    get: async (query = '', count = 20, offset = 0) => {
      const params = { count, offset };
      if (query) params.query = query;
      return axiosInstance.get('/AdminDocuments/GetDocuments', { params });
    },
    getById: async (id) => {
      return axiosInstance.get('/AdminDocuments/GetDocument', { params: { id } });
    },
    create: async (body) => {
      return axiosInstance.post('/AdminDocuments/CreateDocument', body);
    },
    update: async (body) => {
      return axiosInstance.put('/AdminDocuments/UpdateDocument', body);
    },
    delete: async (id) => {
      return axiosInstance.delete('/AdminDocuments/DeleteDocument', { params: { id } });
    },
  },
};
